import React from "react";
import { Route, Redirect } from "react-router-dom";

const PublicRoutes = ({ user, component: Comp, restricted, ...rest }) => {
  return (
    <Route
      {...rest}
      component={(props) =>
        restricted ? (
          user ? (
            <Redirect to="admin" />
          ) : (
            <Comp {...props} user={user} />
          )
        ) : (
          <Comp {...props} user={user} />
        )
      }
    />
  );
};

export default PublicRoutes;
